











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "mapTeamsLimitExceededToToast_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgName",
      "storageKey": null
    }
  ],
  "type": "NotifyTeamsLimitExceeded",
  "abstractKey": null
};

(node ).hash = "8d691b786d05a974c45c8dab2182a9c8";

export default node;
